/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMoeV2AnchorLinkMenuViewProps } from './moe-v2-anchor-link-menu';

const ArrowIcon = () => (
    <svg
        className='moe-anchor-link-menu__arrow'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        aria-hidden='true'
        focusable='false'
        style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
        <line x1='12' y1='6' x2='12' y2='18' stroke='#2D3136' strokeWidth='2.5' strokeLinecap='round' />
        <polyline points='7,13 12,18 17,13' fill='none' stroke='#2D3136' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
);

export default (props: IMoeV2AnchorLinkMenuViewProps) => {
    const { config } = props;
    const menuItems = config.menuItems || [];
    const headingSize = config.headingSize || 'h1';
    const linkSize = config.linkSize || 'h2';
    const topPadding = config.topPadding || '10';
    const heading = config.heading;

    // Split items for two columns, fill down first column before second
    const mid = Math.ceil(menuItems.length / 2);
    const col1 = menuItems.slice(0, mid);
    const col2 = menuItems.slice(mid);

    const LinkHeadingTag = linkSize as keyof JSX.IntrinsicElements;

    return (
        <nav className='moe-v2-module-container moe-anchor-link-menu' aria-label={props.config.moduleAriaLabel || 'Anchor Link Menu'}>
            {(() => {
                const HeadingTag = headingSize ? (headingSize as keyof JSX.IntrinsicElements) : 'h2';
                return (
                    <HeadingTag style={{ paddingTop: topPadding, paddingLeft: '3px' }} className='moe-anchor-link-menu__main-heading'>
                        {heading}
                    </HeadingTag>
                );
            })()}
            <div className='moe-anchor-link-menu__columns'>
                {[col1, col2].map((col, colIdx) => (
                    <ul className='moe-anchor-link-menu__column' key={colIdx}>
                        {col.map((item, idx) => (
                            <li key={`${colIdx}-${idx}`}>
                                <a href={item.link?.destinationUrl} className='moe-anchor-link-menu__link'>
                                    <ArrowIcon />
                                    <LinkHeadingTag className='moe-anchor-link-menu__heading' aria-label={item.itemAriaLabel || ''}>
                                        {item.linkName}
                                    </LinkHeadingTag>
                                </a>
                            </li>
                        ))}
                    </ul>
                ))}
            </div>
        </nav>
    );
};
